import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import jsPDF from 'jspdf'
import html2canvas from "html2canvas"
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'ReversePickAcknowledgment',
  components: {VueElementLoading},
  props: [],
  data() {
    return {
      username: '',
      password: '',
      tokenId: '',
      acknowledgementObj: {},
      isLoadACK: false,
      isDownACK: false,
      isMPS:false,
      mpsDetails:[],
      pickDone:[],
      pickNotDone:[],
      issku:false,
      skuDetails:[],
      mpsTotalQuantity:0,
      skuTotalQuantity:0
    }
  },
  computed: {
  },
  mounted() {
    //console.log('shippingId',this.$route.params.shippingId);
    // this.getAcknowledgementDetails();
    const routePath = window.location.hash.replace(/^#/, '');
    window.location.href = `${window.location.origin+""+routePath}`;
  },
  methods: {
    generatePDF () {
      this.isDownACK = true;
      const doc = new jsPDF();
      /** WITH CSS */
      var canvasElement = document.createElement('canvas');
      const vm = this;
      html2canvas(this.$refs.content, { canvas: canvasElement }).then(function (canvas) {
        const img = canvas.toDataURL("image/jpeg", 0.8);
        doc.addImage(img,'JPEG',15, 40, 180, 150);
        const img2 = canvas.toDataURL("image/jpeg", 0.8);
        doc.addImage(img2,'JPEG',15, 40, 180, 150);
        doc.save("ReversePickAcknowledgment.pdf");
        vm.isDownACK = false;
      });
    },
    getAcknowledgementDetails() {
      this.isLoadACK = true;
      axios.post(apiUrl.api_url + 'expose/get/shipment/acknowledgement/details', {
        'ShippingId': this.$route.params.shippingId,
        'ShipmentType': 'Reverse'
      })
      .then((response) => {
          if(response.data.code == 200) {
            this.isMPS = false
            this.mpsDetails = []
            this.pickDone = []
            this.pickNotDone = []
            this.acknowledgementObj = response.data.data;
            if(response.data.data.issku == '1'){
              this.issku = true;
              this.skuDetails = response.data.data.ProductDetails
              this.skuTotalQuantity = this.skuDetails.length
              if(this.skuDetails.length > 0 ){
                this.skuDetails.map(skuShipment => {
                  skuShipment.ProductName = skuShipment.ProductName
                  skuShipment.ProductID = skuShipment.ProductID
                  if(skuShipment.uniquecode == 'XBU00079'){
                    this.pickDone.push(skuShipment)
                  }else {
                    this.pickNotDone.push(skuShipment)
                  }
                })
              }
            }
            if(response.data.MPSID !== null ){
              this.isMPS = true
              this.mpsDetails = response.data.MPSDeatils
              if(this.mpsDetails.length > 0 ){
                this.mpsTotalQuantity = this.mpsDetails.length
                this.mpsDetails.map(mpsShipment => {
                  mpsShipment.ProductName = mpsShipment.ProductDetails[0].ProductName
                  mpsShipment.ProductID = mpsShipment.ProductDetails[0].ProductID
                  if(mpsShipment.Status == '1'){
                    this.pickDone.push(mpsShipment)
                  }else {
                    this.pickNotDone.push(mpsShipment)
                  }
                })
              }
            }
            this.isLoadACK = false;
          } else {
            this.isLoadACK = false;
          }
        })
      .catch((httpException) => {
        this.isLoadACK = false;
        console.error('exception is:::::::::', httpException)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ReversePickAcknowledgment/ReversePickAcknowledgment.component.js